export enum GateOperationEnum {
  // Keeps the gate closed until it is manually opened (Lock Close)
  Lock = 1,
  // Open gate and close automatically after the settled time (Trigger Open)
  Unlock = 2,
  // Keeps the gate open until it is manually closed (Lock Open)
  UnlockHold = 3,
}

export enum RelayOperationEnum {
  //Seconds > 0 ? EnergizeTimeOverride : MomentaryOn
  EnergizeTimeOverride = 1,
  //Open
  HoldEnergized = 2,
  //Close
  Deenergized = 3,
}

export interface ICardAccessPanel {
  panelNumber: number | null;
  description: string | null;
  deviceName: string | null;
  groupName: string | null;
  panelName: string | null;
}
